export default "__VITE_ASSET__CeBUDp1d__"